'use client';

import { formatDate } from 'dates';
import { TFunction } from 'i18next';
import { useTranslation } from 'react-i18next';
import { CardMobileSwiper, ListItemGroup, TabPanel } from 'ui';
import { useResolution } from 'ui/hooks';
import { Assignment, Description, Event, Tag } from 'ui/icons';

import { getStatusTranslation } from '~/contract/utils';
import { Contract } from '~/data';

interface Props {
  contract: Contract;
}

const buildData = (contract: Contract, t: TFunction) => {
  return [
    {
      details: [
        {
          icon: Tag,
          subtitle: t('common:tabPanelTabs.contractData.contractNumber'),
          title: contract.contractNumber,
        },
        {
          icon: Description,
          subtitle: t('common:tabPanelTabs.contractData.contractType'),
          title: contract.contractType,
        },
        {
          icon: Event,
          subtitle: t('common:tabPanelTabs.contractData.startDate'),
          title: formatDate({ date: contract.startDate! }),
        },
        {
          icon: Event,
          subtitle: t('common:tabPanelTabs.contractData.endDate'),
          title: contract.endDate ? formatDate({ date: contract.endDate }) : '',
        },
        {
          icon: Assignment,
          subtitle: t('common:tabPanelTabs.contractData.status'),
          title: getStatusTranslation({ status: contract.status, t }),
        },
      ],
      key: 'contractData',
    },
  ];
};

const ContractDetailedData = ({ contract }: Props) => {
  const { t } = useTranslation('contracts');
  const { isTablet } = useResolution();

  const data = buildData(contract, t);

  const listData = data.map(({ key, details }) => ({
    content: <ListItemGroup data={details} />,
    label: t(`common:tabPanelTabs.${key}.tabName`),
  }));

  return isTablet ? <TabPanel tabs={listData} /> : <CardMobileSwiper elements={listData} />;
};

export default ContractDetailedData;
